/**
 * 안건 목록의 범위(화면 상단 탭) 값과, **이미 열려 있는** 화면에 그 범위를 알리는 이벤트 이름.
 *
 * 왜 화면 파일이 아니라 여기 있나: 홈의 회의 안건 카드가 같은 값을 쓴다. MeetingAgenda.js 에서
 * 가져오면 화면 모듈 전체(에디터·그리드까지)가 홈 번들로 딸려 온다 — 상수만 떼어 두면
 * 양쪽이 같은 값을 쓰면서도 번들은 그대로다.
 */
export const AGENDA_SCOPE = {
  ALL: "ALL",
  STARRED: "STARRED",
  MINE: "MINE",
  DRAFT: "DRAFT"
};

/**
 * 안건 화면의 탭을 밖에서 바꾼다. `detail: { scope }`.
 *
 * <p>탭이 아직 없으면 redux 뷰 상태(scope)가 초기값을 정하므로 이 이벤트가 필요 없다.
 * 이미 열려 있을 때가 문제다 — TabContainer 는 비활성 탭을 **숨길 뿐 언마운트하지 않아서**
 * 화면이 다시 mount 되지 않고, 따라서 초기값을 다시 읽지 않는다. 그때는 이것이 유일한 통로다.
 */
export const AGENDA_SCOPE_EVENT = "plannel:meetingAgendaScope";
